/**
 * Angular doesn't support ICU expressions in attributes yet, this hack fixes that
 * @param ref
 */
export function i18nICUAttribute(ref: HTMLSpanElement) {
  return removeHtmlComments(ref.innerHTML);
}

function removeHtmlComments(html: string) {
  return html.replace(/<!--[\s\S]*?-->/g, '');
}
